import React from "react";

export default React.createContext({
  classes: {},
  md: 3,
  xs: 6,
});
